import { LeafIconLibrary } from "../components/icon/library.js";
import { svgToDataURI } from "../components/icon/library.js";
import { systemIcons } from "../components/icon/iconset.system.js";
const library = LeafIconLibrary.getInstance();
const registerIconSet = (name, resolver, mutator) => library.add(name, resolver, mutator);
const unregisterIconSet = (name) => library.remove(name);
export {
  LeafIconLibrary,
  registerIconSet,
  svgToDataURI,
  systemIcons,
  unregisterIconSet
};
//# sourceMappingURL=icon-library.js.map
